export default "__VITE_ASSET__99a9a7ae__"